module.exports = __webpack_public_path__ + "img/img (9).26d85969.jpg";